import { Line } from "@ant-design/charts";

export default function InboundCapacityChart({
  data = [],
  capacity = 100,
  height = 150,
}) {
  const capNum = Number(capacity) || 100;
  const maxInbound = Math.max(
    0,
    ...data.map((x) => Number(x.inbound) || 0)
  );
  // beri padding 10% agar garis kapasitas tidak mentok di atas
  const yMax = Math.ceil(Math.max(capNum, maxInbound) * 1.1) || 10;

  // Transformasi data ke format 'long' agar terbaca sebagai 2 garis terpisah.
  // dukung capacity per-titik dari API (x.capacity), fallback ke prop capacity.
  const chartData = data.flatMap((x) => [
    {
      time: x.time,
      type: "Pergerakan Barang Masuk (Inbound)",
      value: Number(x.inbound) || 0,
    },
    {
      time: x.time,
      type: "Kapasitas Maksimal Gudang",
      value: Number(x.capacity ?? capNum) || 0,
    },
  ]);

  const config = {
    data: chartData,
    xField: "time",
    yField: "value",
    colorField: "type",
    shapeField: "smooth",
    scale: {
      color: {
        range: ["#287db8", "#e89a2b"],
      },
      y: {
        min: 0,
        max: yMax,
      },
    },
    axis: {
      x: {
        labelFontSize: 9,
        labelFill: "#4b5563",
        lineStroke: "#cbd5e1",
        tick: false,
      },
      y: {
        labelFontSize: 9,
        gridStroke: "#e8edf2",
        title: "Ton / TEUs",
        titleFontSize: 9,
        titleSpacing: 10,
      },
    },
    interaction: {
      tooltip: {
        shared: true,
        showMarkers: true,
      },
    },
    legend: {
      position: "top",
      direction: "row",
    },
    height: height,
    autoFit: true,
  };

  return <Line {...config} />;
}
